import React from "react";
import PropTypes from "prop-types";

const ConfirmModal = ({ title, onConfirm, onCancel, confirmButtonTitle = "Confirm", cancelButtonTitle = "Cancel" }) => (
    <div>
        <h4 className="mb-4 mt-5 text-center">
            {title}
        </h4>

        <div className="text-right">
            <button className="btn btn-success mr-2" onClick={onConfirm}>
                {confirmButtonTitle}
            </button>
            <button className="btn btn-outline-danger" onClick={onCancel}>
                {cancelButtonTitle}
            </button>
        </div>
    </div>
);

ConfirmModal.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ConfirmModal;
